<template>
  <div class="doctor-list">
    <div class="doctor-list__header">
      <h2 class="doctor-list__title">{{ $$FormData.title }}</h2>
      <div v-if="$$FormData.show_all" class="doctor-list__more">
        {{ isBeauty ? '全部美容师' : '全部医生' }} &gt;
      </div>
    </div>
    <div class="doctor-list__content">
      <!-- 纵向列表 -->
      <template v-if="$$FormData.layout === 'list'">
        <div
          v-for="item in doctors"
          :key="item.__key"
          class="doctor-card list"
        >
          <img
            class="doctor-card__avatar"
            :src="item.avatar || defaultAvatar"
          />
          <div class="doctor-card__info">
            <div class="doctor-card__name">
              {{ isBeauty ? item.beauticianName : item.doctorName }}
              <span v-if="item.gender && item.gender !== 0" class="doctor-card__gender" :class="{ male: item.gender === 1 || item.gender === '男', female: item.gender === 2 || item.gender === '女' }">
                <i v-if="item.gender === 1 || item.gender === '男'" class="ri-men-line"></i>
                <i v-else class="ri-women-line"></i>
              </span>
            </div>
            <div v-if="item.workYears != null && item.workYears > 0" class="doctor-card__years">从业{{ item.workYears }}年</div>
            <div class="doctor-card__title">{{ item.jobTitle || "暂无职称" }}</div>
            <div class="doctor-card__specialty">擅长领域: {{ item.specialty || item.specialties || "暂无内容" }}</div>
            <div v-if="item.tagList && item.tagList.length" class="doctor-card__tags">
              <span v-for="(tag, index) in item.tagList" :key="index" class="doctor-card__tag">{{ tag }}</span>
            </div>
          </div>
        </div>
      </template>

      <!-- 横向滚动 -->
      <template v-else-if="$$FormData.layout === 'scroll'">
        <div class="doctor-scroll">
          <div
            v-for="item in doctors"
            :key="item.__key"
            class="doctor-card scroll"
          >
            <img
              class="doctor-card__avatar scroll-avatar"
              :src="item.avatar || defaultAvatar"
            />
            <div class="doctor-card__info">
              <div class="doctor-card__name">
                {{ isBeauty ? item.beauticianName : item.doctorName }}
                <span v-if="item.gender && item.gender !== 0" class="doctor-card__gender" :class="{ male: item.gender === 1 || item.gender === '男', female: item.gender === 2 || item.gender === '女' }">
                  <i v-if="item.gender === 1 || item.gender === '男'" class="ri-men-line"></i>
                  <i v-else class="ri-women-line"></i>
                </span>
              </div>
              <div v-if="item.workYears != null && item.workYears > 0" class="doctor-card__years">从业{{ item.workYears }}年</div>
              <div class="doctor-card__title">{{ item.jobTitle || "暂无职称" }}</div>
              <div class="doctor-card__specialty">擅长领域: {{ item.specialty || item.specialties || "暂无内容" }}</div>
              <div v-if="item.tagList && item.tagList.length" class="doctor-card__tags">
                <span v-for="(tag, index) in item.tagList" :key="index" class="doctor-card__tag">{{ tag }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "DoctorListPreview",
  data() {
    return {
      defaultAvatar: require("@/assets/icon-component-label_TitleText.png"),
      localDoctors: [],
    };
  },
  computed: {
    doctors() {
      return this.localDoctors.length > 0 ? this.localDoctors : (this.$$FormData.doctors || []);
    },
    isBeauty() {
      const businessType = this.$$Foundation.getURLSearchParma("businessType");
      return businessType == 'LIFE';
    },
  },
  watch: {
    '$$FormData.doctors': {
      handler(newVal) {
        // 深拷贝确保响应式更新
        this.localDoctors = JSON.parse(JSON.stringify(newVal || []));
        console.log('Doctors updated:', this.localDoctors);
      },
      deep: true,
      immediate: true
    }
  },
};
</script>

<style lang="scss" scoped>
.doctor-list {
  padding: 10px;
  background: #fff;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  &__title {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }

  &__more {
    font-size: 12px;
    cursor: pointer;
  }
}

.line {
  height: 10px;
  width: 1px;
  background: #999999;
  display: inline-block;
  margin: 0 5px;
}

.doctor-scroll {
  display: flex;
  overflow-x: auto;
  padding-bottom: 5px;

  &::-webkit-scrollbar {
    display: none;
  }
}

.doctor-card {
  box-sizing: border-box;
  padding: 10px;
  
  &.list {
    display: flex;
    width: 100%;
    align-items: flex-start;
  }

  &.scroll {
    flex-shrink: 0;
    width: 45%;
    display: flex;
    flex-direction: column;
    
    .scroll-avatar {
      margin-bottom: 8px;
    }
  }

  &__avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 10px;
    background: #909399;
    flex-shrink: 0;
  }

  &__info {
    flex: 1;
    min-width: 0;
  }

  &__name {
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__years {
    font-size: 11px;
    color: #3265F6;
    margin-top: 4px;
  }

  &__title {
    font-size: 12px;
    color: #999999;
    margin-top: 4px;
  }

  &__specialty {
    font-size: 11px;
    color: #999999;
    margin-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 6px;
  }

  &__tag {
    font-size: 11px;
    padding: 2px 8px;
    background: #E6ECFF;
    color: #586782;
    border-radius: 2px;
    white-space: nowrap;
  }
}
.doctor-card__gender{
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #fff;
  
  .ri-men-line,
  .ri-women-line {
    font-size: 10px;
    line-height: 1;
  }
  
  &.male {
    background-color: #2A82E4;
  }
  
  &.female {
    background-color: #F19780;
  }
}
</style>